import React from 'react';

import {useSelector} from 'react-redux';

// import ModalCommon from '@/components/modal/ModalCommon';
import ModalCommonButtons from '@/components/modal/ModalCommonButtons';
import ModalCommonContent from '@/components/modal/ModalCommonContent';
import ModalCommonFooter from '@/components/modal/ModalCommonFooter';
import ModalCommonHeader from '@/components/modal/ModalCommonHeader';
import {getActions, getContent, getHeader} from '@/selectors/modalSelector';

// function ModalGeneric() {
//   const {show, size, inlineMessage, header, content, actions} = useSelector(getModalCommon);

//   return (
//     <ModalCommon
//       actions={actions}
//       content={content}
//       header={header}
//       hideCloseButton
//       inlineMessage={inlineMessage}
//       size={size}
//       open={show}
//     />
//   );
// }

// export default ModalGeneric;

function ModalGenericHeader() {
  const header = useSelector(getHeader);

  return <ModalCommonHeader>{header}</ModalCommonHeader>;
}

function ModalGenericFooter() {
  const actions = useSelector(getActions);
  console.log({actions});
  return (
    <ModalCommonFooter>
      <ModalCommonButtons data={actions} />
    </ModalCommonFooter>
  );
}

function ModalGenericContent() {
  const content = useSelector(getContent);

  return <ModalCommonContent>{content}</ModalCommonContent>;
}

const ModalGeneric = {
  Header: ModalGenericHeader,
  Footer: ModalGenericFooter,
  Content: ModalGenericContent,
};

export default ModalGeneric;
